import { useHistory } from "react-router-dom";

import ActiveItemsCard from "../ActiveItemsCard";
import { LoadingCard } from "../LoadingCard";
import { CreateItemCard } from "./CreateItemCard";

type ActiveBudgetsCardProps = {
  numberOfBudgets: number;
  numberOfBudgetsNearThreshold: number;
  loading: boolean;
  totalCostAtRisk: number;
};

export const ActiveBudgetsCard = ({
  numberOfBudgets,
  numberOfBudgetsNearThreshold,
  loading,
  totalCostAtRisk,
}: ActiveBudgetsCardProps) => {
  const history = useHistory();

  if (loading) {
    return <LoadingCard title="Active budgets" />;
  }

  if (numberOfBudgets === 0) {
    return (
      <CreateItemCard
        title="Active budgets"
        buttonLabel="Create budget"
        createMsg="You haven't set up any budgets yet"
        onButtonClick={() => {
          history.push("./monitor/budgets/create");
        }}
        buttonDataCy="create-budget-btn"
      />
    );
  }

  return (
    <ActiveItemsCard
      title="Active budgets"
      value={numberOfBudgets}
      cloudCostsAtRisk={totalCostAtRisk}
      dataIcon="warning"
      trend={numberOfBudgetsNearThreshold > 0 ? `${numberOfBudgetsNearThreshold} near threshold` : 0}
      trendColor="warning.main"
      buttonLink="./monitor/budgets"
    />
  );
};
